import React, { useState, useEffect } from "react";
import { getUserById, UpdateCounsellor } from "../../api/api";
import { environment } from "../../../environments/environments";
import "../CounsellorallEditPages/Availabilityupdate.css";
import { useNavigate } from "react-router-dom";

const timeSlots = Array.from({ length: 16 }, (_, i) => {
  const hour = 8 + i;
  return `${hour.toString().padStart(2, "0")}:00`;
});

const defaultDays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const Availabilityupdate = ({ navigation, route }) => {
  const initialValues = route?.params?.availability || [];
  const [commingData, setCommingData] = useState(null);

  const navigate = useNavigate();
  useEffect(() => {
    const getUserdata = async () => {
      try {
        // const userData = await AsyncStorage.getItem('currentUser');
        const userData = localStorage.getItem("currentUser");
        const parsedUserData = JSON.parse(userData);
        const _id = parsedUserData?.id || parsedUserData?._id;

        if (_id) {
          const res = await getUserById({ user_id: _id });
          console.log("getUserById_data", JSON.stringify(res));

          const availableDays = res?.data?.available || [];

          const mappedAvailability = defaultDays.map((day) => {
            const existing = availableDays.find((d) => d.day === day);
            return (
              existing || {
                day,
                start: "10:00",
                till: "20:00",
                off_day: "0",
              }
            );
          });

          setAvailability(mappedAvailability);
          setCommingData(res?.data);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      } finally {
        // setLoading(false);
      }
    };

    getUserdata();
  }, []);

  const [availability, setAvailability] = useState(
    defaultDays.map((day) => {
      const existing = initialValues.find((d) => d.day === day);
      return (
        existing || {
          day,
          start: "10:00",
          till: "20:00",
          off_day: "0",
        }
      );
    })
  );

  const updateTime = (index, type, value) => {
    const updated = [...availability];
    updated[index][type] = value;
    setAvailability(updated);
  };

  const toggleOffDay = (index) => {
    const updated = [...availability];
    updated[index].off_day = updated[index].off_day === "1" ? "0" : "1";
    setAvailability(updated);
  };

  const renderItem = (item, index) => (
    <div className="availability-day-container" key={index}>
      <div>
        <p className="availability-day-label">{item.day}</p>
        <div className="availability-row">
          <p className="availability-label">Start:</p>
          <select
            value={item.start}
            className="availability-picker"
            onChange={(e) => updateTime(index, "start", e.target.value)}
          >
            {timeSlots.map((time) => (
              <option key={time} value={time}>
                {time}
              </option>
            ))}
          </select>
          <p className="availability-label">Till:</p>
          <select
            value={item.till}
            className="availability-picker"
            onChange={(e) => updateTime(index, "till", e.target.value)}
          >
            {timeSlots.map((time) => (
              <option key={time} value={time}>
                {time}
              </option>
            ))}
          </select>
          <div className="availability-switch-row">
            <p>{item.off_day === "0" ? "On" : "Off"}</p>
            <input
              type="checkbox"
              checked={item.off_day === "0"}
              onChange={() => toggleOffDay(index)}
            />
          </div>
        </div>
      </div>
    </div>

  );

  const handleSave = async () => {
    const userData = localStorage.getItem("currentUser");
    const parsedUserData = JSON.parse(userData);
    const _id = parsedUserData?.id || parsedUserData?._id;

    try {
      const values = {
        counsellor_id: _id,
        available: availability,
      };
      const updateData = await UpdateCounsellor(values);

      if (updateData?.success) {
        alert(updateData.message);
        navigate("/CounsellorSidebar/CounsellorEditProfile");
      } else {
        alert(updateData.message);
      }
    } catch (error) {
      console.error("Error updating:", error);
    }
  };

  return (
    <div className="container">
      <div className="availability-container">
        <div className="availability-day-list">
          {availability.map((item, index) => renderItem(item, index))}
        </div>

        <div className="availability-footer">
          <button className="availability-ok-button" onClick={handleSave}>
            Update
          </button>
          <button
            className="availability-cancel-button"
            onClick={() => window.history.back()}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default Availabilityupdate;
